import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const Coutomer = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className='max-w-4xl mx-auto p-4 py-10 md:py-20 text-justify'>
   

    

      <h2 className="text-xl font-bold mt-4 mb-2">Welcome to Carizo.in Customer Support</h2>
      <p className='py-2'>
        At Carizo.in, we are dedicated to providing you with exceptional customer support to
        enhance your shopping experience for high-quality auto parts. Whether you have
        questions about our products, need assistance with your order, or require technical
        guidance, our team is here to help.
      </p>
      <p className='py-2'>
        <strong>Contact Information:</strong>
        <br />
        Customer Support Email: support@carizo.in
        <br />
        Customer Support Hotline: 98100-21158
      </p>
      <p className='py-2'>
        <strong>Frequently Asked Questions (FAQs):</strong>
        <br />
        1. How do I place an order on Carizo.in?
        <br />
        To place an order, simply browse through our website, add the desired auto parts to
        your cart, and proceed to checkout. Follow the on-screen instructions to complete your
        purchase.
        <br />
        2. Can I track my order?
        <br />
        Yes, once your order is dispatched, you will receive a confirmation email with a tracking
        number. You can use this number to track your order through our website or the courier
        company's portal.
        <br />
        3. What payment methods do you accept?
        <br />
        We accept various payment methods, including credit/debit cards, net banking, and
        digital wallets. All transactions on Carizo.in are secure and encrypted to ensure your
        financial information is protected.
        <br />
        4. Do you offer international shipping?
        <br />
        Currently, we only offer shipping within India. We are working on expanding our shipping
        options to serve our international customers better.
        <br />
        5. How can I return a product?
        <br />
        If you are not satisfied with your purchase, please contact our customer support within 7
        days of receiving the order. We will guide you through the return process and assist you
        in obtaining a replacement or refund.
      </p>
      <p className='py-2'>
        <strong>Technical Support:</strong>
        <br />
        If you have technical questions about the compatibility or installation of a specific auto
        part, our technical support team is ready to assist you. Please provide detailed
        information about your vehicle, and our experts will help you find the right solution.
      </p>
      <p className='py-2'>
        <strong>Customer Feedback:</strong>
        <br />
        We value your feedback! Your insights help us improve our services. If you have any
        suggestions, concerns, or compliments, please share them with us at support@carizo.in.
        <br />
        At Carizo.in, our goal is to ensure your satisfaction with every purchase. Thank you for
        choosing us for your auto parts needs!
        <br />
        Note: Customize the contact information and details based on the actual information
        relevant to https://www.carizo.in/ and Cynor India.
      </p>
    </div>
  );
};

export default Coutomer;
